<template>
  <div class="marketing-automation-detail-header-saving">
    <i class="mdi mdi-content-save-outline"
       :class="{ 'cursor-wait': saving }"></i>

    <p class="text-bold marketing-automation-detail-header-saving-text">
      {{ saving ?  savingText : savedText }}
    </p>
  </div>
</template>

<script>
import {i18n} from "@packages/I18n"
export default {
  components: {},

  props: {
    saving: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {};
  },

  computed: {
      savingText() {
          return i18n.t('message.marketingGenerics.message.saving')
      },
      savedText() {
          return i18n.t('message.marketingGenerics.message.saved')
      }
  },

  mounted() {},

  beforeDestroy() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.marketing-automation-detail-header-saving {
  display: flex;
  align-items: center;
  color: $grey-4;
  min-width: 135px;
  margin-right: 10px;

  .marketing-automation-detail-header-saving-text {
    margin: 0;
  }

  .mdi {
    font-size: 26px;
    padding: 0 5px;

    &:last-child {
      padding: 0 30px 0 10px;
    }
  }
}
</style>
